var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCannedProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#273851;}\n\t.st1{fill:#B9CFC0;}\n\t.st2{fill:#FFF8CF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.26,61.62,185.55,104.31,185.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.41,71.68c0-0.13-0.02-0.25-0.05-0.36c-0.63-6.66-18.43-10.14-36.03-10.14c-17.6,0-35.4,3.48-36.03,10.14 c-0.03,0.12-0.05,0.24-0.05,0.36v69.47c0,0.11,0.02,0.22,0.04,0.33c0.39,8.58,16.07,15.25,36.04,15.25 c19.96,0,35.65-6.67,36.04-15.25c0.02-0.11,0.04-0.21,0.04-0.33V71.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.54,94.39v24.86c0,0.12-0.03,0.21-0.06,0.3c-0.33,7.65-14.34,13.62-32.16,13.62s-31.8-5.97-32.16-13.62 c-0.03-0.09-0.03-0.18-0.03-0.3V94.42c5.07,2.01,13.53,3.75,24.48,4.35c2.46,0.27,5.04,0.39,7.71,0.39c2.7,0,5.31-0.15,7.77-0.42 h0.27C123.19,98.14,131.53,96.37,136.54,94.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.13,71.49c0-5.93,14.02-10.32,36.17-10.32c22.15,0,36.17,5.03,36.17,10.32 c-6.77,2.78-19.49,5.22-36.17,5.22C87.62,76.72,74.9,74.27,68.13,71.49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCannedProducts);
export default __webpack_public_path__ + "static/media/Canned_products.da74aaa4df80250696aff39eda41c754.svg";
export { ForwardRef as ReactComponent };